import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/programer-prava.png'


const _withScopeId = n => (_pushScopeId("data-v-d2cd8aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-top relative isolate place-items-center overflow-hidden bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 min-h-screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute inset-0 -z-10 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("pattern", {
      id: "0787a7c5-978c-4f66-83c7-11c213f99cb7",
      width: "200",
      height: "200",
      x: "50%",
      y: "-1",
      patternUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M.5 200V.5H200",
        fill: "none"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "100%",
    height: "100%",
    "stroke-width": "0",
    fill: "url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
  })
], -1))
const _hoisted_3 = { class: "m-auto top-0 lg:mt-20 mt-10 gap-10 min-h-fit max-w-fit sm:max-w-screen justify-center px-4 pb-12 pt-4 my-auto sm:pb-32 lg:flex lg:px-8 lg:py-40" }
const _hoisted_4 = {
  class: "m-auto mt-20 sm:max-w-full lg:max-w-xl lg:flex-shrink-0 lg:pt-8 lg:pr-10",
  "data-aos": "fade-right"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mt-6 flex flex-wrap text-5xl font-bold text-gradient bg-gradient-to-r from-indigo-100 from-10% via-sky-300 via-30% to-emerald-200 to-90% sm:text-6xl" }, "Your Web Development Destination", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-lg leading-6 text-gray-600" }, "Functional websites with passion and precision. Let's transform your ideas into digital reality.", -1))
const _hoisted_7 = { class: "mt-6 flex items-center gap-x-6" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<svg width=\"200\" height=\"100\" data-v-d2cd8aea><defs data-v-d2cd8aea><linearGradient id=\"gradient\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\" data-v-d2cd8aea><stop offset=\"0%\" style=\"stop-color:blue;stop-opacity:1;\" data-v-d2cd8aea></stop><stop offset=\"100%\" style=\"stop-color:teal;stop-opacity:1;\" data-v-d2cd8aea></stop></linearGradient></defs><path id=\"static-rectangle\" d=\"M15 10 a5 5 0 0 1 5 -5 h160 a5 5 0 0 1 5 5 v70 a5 5 0 0 1 -5 5 h-160 a5 5 0 0 1 -5 -5 z\" stroke=\"url(#gradient)\" stroke-width=\"2\" fill=\"transparent\" data-v-d2cd8aea></path><path id=\"rectangle\" d=\"M15 10 a5 5 0 0 1 5 -5 h160 a5 5 0 0 1 5 5 v70 a5 5 0 0 1 -5 5 h-160 a5 5 0 0 1 -5 -5 z\" stroke=\"url(#gradient)\" stroke-width=\"2\" fill=\"transparent\" data-v-d2cd8aea></path><text x=\"50%\" y=\"55%\" text-anchor=\"middle\" fill=\"#4b5563\" font-size=\"1.5rem\" data-v-d2cd8aea>Contact Us</text></svg>", 1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  class: "m-2 lg:pl-10 max-w-fit sm:max-w-2xl rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4",
  ref: "animatedElement",
  "data-aos": "fade-left"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Programmer image"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: $setup.navigation[0].href,
            class: "button-container"
          }, _hoisted_10, 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, _hoisted_13, 512)
    ])
  ]))
}